import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { NewsletterListFacade } from './newsletter-list.facade';
import { loadStoreState, setInitialStoreState } from '../../../../../common/utils';

@Injectable({
  providedIn: 'root',
})
export class NewsletterListGuard {
  constructor(private newsletterListFacade: NewsletterListFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return loadStoreState(this.newsletterListFacade);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.newsletterListFacade);
  }
}
